var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ComputationItem',{attrs:{"id":_vm.id,"back-link":_vm.$router.resolve({ name: 'computations' }).href}})}
var staticRenderFns = []

export { render, staticRenderFns }